import { render, staticRenderFns } from "./OAuthCallbackPage.vue?vue&type=template&id=ce465fae&scoped=true"
import script from "./OAuthCallbackPage.vue?vue&type=script&lang=js"
export * from "./OAuthCallbackPage.vue?vue&type=script&lang=js"
import style0 from "./OAuthCallbackPage.vue?vue&type=style&index=0&id=ce465fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce465fae",
  null
  
)

export default component.exports